<template>
  <validation-observer ref="typetalkForm" class="typetalk-form">
    <b-modal
      id="typetalk-modal"
      :no-close-on-backdrop="true" title="TypeTalkへの投稿"
      size="md"
    :hide-footer="true"
    >
     <p class="sm">
        成果「{{achievementName}}」をSecHack365のみんなにも伝えませんか？
      </p>
      <b-form @submit.stop.prevent="send">
        <validation-provider name="投稿内容" rules="max:4000|required" v-slot="validationContext">
          <b-form-textarea
            id="message"
            :rows="5"
            v-model="message"
            :state="getValidationState(validationContext)"
            placeholder="投稿内容を入力してください(必須・4000字以内)"
            @input="editMessage"
          ></b-form-textarea>
          <b-form-invalid-feedback id="input-comment-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </validation-provider>
        <b-nav align="right" class="mt-1">
          <b-button class="secondary mr-1" inline @click="closeModal">キャンセル</b-button>
          <app-button class="default"
        :disabled="isDisabled" type="submit" inline >修了生の成果トピックへ投稿する</app-button>
        </b-nav>
      </b-form>
    </b-modal>
  </validation-observer>
</template>

<script>
import { mapState } from 'vuex'
import AppButton from '@/components/presentationals/AppButton'

export default {
  name: 'Typetalk',
  props: {
    achievementName: String,
    achievementId: Number
  },
  components: {
    AppButton
  },
  data() {
    return {
      message: this.defaultMessage,
      isDisabled: false
    }
  },
  computed: {
    ...mapState({
      loginUserName: (state) => state.auth.loginUserName
    }),
    defaultMessage() {
      return this.loginUserName + 'です、' + this.achievementName + 'の成果を達成しました！'
    }
  },
  methods: {
    editMessage(value) {
      this.message = value
      this.isDisabled = this.updateIsDisabled()
    },
    closeModal() {
      this.$bvModal.hide('typetalk-modal')
    },
    async updateIsDisabled() {
      const result = await this.$refs.typetalkForm.validate()
      this.isDisabled = !result
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    send() {
      this.$emit('click-send', this.message, this.achievementId)
    }
  },
  watch: {
    achievementName() {
      this.message = this.defaultMessage
    }
  }
}
</script>
